import { ContentAccessRoleApi } from './permission-api-client';
import { initializePermissionApi } from './utils';

export const contentAccessRoleApi = initializePermissionApi(ContentAccessRoleApi);
